// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { PopOver } from '../../../UI/PopOver/PopOver';
import { LinkComponent } from '../../../../../web-utils/src/UI/Component/React/V1/LinkComponent/LinkComponent';

import { selectEquipmentGroups } from '../../../../store/equipment/equipmentSelectors';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';

import styles from '../Navigation.module.css';
import button from '../../../UI/Button/Button.module.css';
import { CONTROLLABLE_STUDIO_GROUP_TYPE_ID } from '../../../../utils/sceneEquipmentsConfig.js';
import { NODES_BASE_PATH } from '../../../../routes/Routes/NodesRoutes/nodesBasePath';

export const CameraNavigation = () => {
  const equipmentGroups = useSelector(selectEquipmentGroups);

  const isMobile = useMediaQuery('(max-width: 768px)');

  const cameraGroups = useMemo(() => {
    // TODO better as buttons with navigate rather than <a>
    const studios = equipmentGroups.filter(
      g =>
        g.parent_uuid === '14596d54-c88e-45b6-acb9-613850d603fe' && // Facility
        g.equip_group_type_uuid === CONTROLLABLE_STUDIO_GROUP_TYPE_ID
    );
    return studios
      .map(s => {
        const cameraGroup = equipmentGroups.find(g => g?.parent_uuid === s?.equip_group_uuid);

        return {
          id: s?.equip_group_uuid,
          name: s.name,
          link:
            cameraGroup &&
            `${NODES_BASE_PATH}/${s?.equip_group_uuid}/cameracontrol/${cameraGroup?.equip_group_uuid}`,
          lockedLink: `${NODES_BASE_PATH}/equipmentGroup/${s?.equip_group_uuid}`,
        };
      })
      .filter(f => f.link);
  }, [equipmentGroups]);

  const isLocked = useCallback(
    id => equipmentGroups.some(g => g.equip_group_uuid === id && g?.lock?.length > 0),
    [equipmentGroups]
  );

  return (
    <PopOver
      color=''
      iconType='camera'
      fill='var(--color-light)'
      stroke='none'
      hoverEffect={true}
      classname={button.btnNavigation}
      buttonText={isMobile ? 'Studios' : null}
    >
      {({ setIsOpen }) => (
        <div className={styles.padding}>
          {cameraGroups?.length ? (
            <div>
              <h3 className={styles.borderBottom}>Studios</h3>
              {cameraGroups?.map(el => {
                const isGroupLocked = isLocked(el.id);
                return (
                  <LinkComponent
                    key={el.id}
                    href={el.link}
                    iconType={isGroupLocked ? 'lock' : 'camera'}
                    stroke='var(--color-light)'
                    onClick={() => setIsOpen(false)}
                  >
                    {el.name}
                  </LinkComponent>
                );
              })}
            </div>
          ) : (
            <div className={styles.item}>
              <p>No studios found</p>
            </div>
          )}
        </div>
      )}
    </PopOver>
  );
};
